import { observer } from 'mobx-react'
import React, { CSSProperties } from 'react'
import { ExternalLink } from 'shared-components/ExternalLink/ExternalLink'

interface ICollection {
  contractAddress: string
  linkPath: string
  filePath: string
  nftTokens: INftToken[]
}

interface INftToken {
  name: string
  tokenId: string
  src: string
  description: string
}

const collection: ICollection = {
  contractAddress: '0x495f947276749ce646f68ac8c248420045cb7b5e',
  linkPath: 'https://opensea.io/assets/ethereum/',
  filePath: 'https://openseauserdata.com/files/',
  nftTokens: [
    {
      name: 'Mr. OOki',
      tokenId: '64093593714290136112596889839166670846544561855086852164347192949043422560257',
      src: '6d26a3e1858af6789ce8ff8c79c9ba5d',
      description: 'The first NFT of the Ooki collection to celebrate the launch of ooki.com.',
    },
    {
      name: 'Ooki Korea',
      tokenId: '51104822734232092166983300974407982455056227197551392102799214882345149530113',
      src: 'ceb1bba8f2bb466f727ef0dc785e4084',
      description: 'The second NFT of the Ooki collection.',
    },
    {
      name: 'Ooki Japan',
      tokenId: '51104822734232092166983300974407982455056227197551392102799214883444661157889',
      src: '3885d9f3d94421192028698f3e1be4b8',
      description:
        'This limited edition NFT is the third in a series created to celebrate the launch of Ooki.com and features an avatar representing the spirit of the Ooki Japan Community of DeFi traders, borrowers, lenders.',
    },
  ],
}

const styles: Record<string, CSSProperties> = {
  grid: {
    gridTemplateColumns: 'repeat(auto-fit, minmax(330px, 1fr))',
  },
}

export function NftCollection() {
  return (
    <div className="panel--simple md-padded-2">
      <h3 className="title-section lex-row-center">{"Our NFT's"}</h3>

      <div className="ui-grid" style={styles.grid}>
        {collection.nftTokens.map((token) => {
          const link = `${collection.linkPath}${collection.contractAddress}/${token.tokenId}`
          return (
            <div key={token.tokenId}>
              <iframe
                className="block width-100p panel--simple margin-bottom-1"
                height="315"
                src={`${collection.filePath}${token.src}.mp4`}
                title={token.name}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
              <ExternalLink showIcon href={link}>
                <h4 className="h4 txt-size-12 txt-default link--hover">{token.name}</h4>
              </ExternalLink>
              <p className="margin-0 txt-explanation">{token.description}</p>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default observer(NftCollection)
